import React from "react";
import { ColorIconProps, getColorIconSize } from "./utils";

const EnterpriseTierIcon: React.FC<ColorIconProps> = ({
  size = "default",
  className,
}) => {
  return (
    <svg
      width={getColorIconSize(size)}
      height={getColorIconSize(size)}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 24 24"
    >
      <path
        d="M10.8333 2.15787L21.3333 7.94735V21.8421H10.8333V2.15787Z"
        fill="var(--cdl-accent-fg-base)"
      />
      <path
        d="M10.242 1.15941C10.5982 0.951662 11.0384 0.946796 11.3996 1.14584L21.8996 6.93532C22.27 7.13954 22.5 7.52684 22.5 7.94735V21.8421C22.5 22.4816 21.9777 23 21.3333 23H10.8333C10.189 23 9.66667 22.4816 9.66667 21.8421V2.15787C9.66667 1.7476 9.88575 1.36747 10.242 1.15941ZM12 20.6842H20.1667V8.62807L12 4.12539V20.6842Z"
        fill="var(--cdl-accent-fg-base)"
      />
      <path
        d="M2.66667 10.2631H13.1667V21.8421H2.66667V10.2631Z"
        fill="var(--cdl-bg-base)"
      />
      <path
        d="M13.1667 9.10525C13.811 9.10525 14.3333 9.62365 14.3333 10.2631V21.8421C14.3333 22.4816 13.811 23 13.1667 23H2.66667C2.02233 23 1.5 22.4816 1.5 21.8421V10.2631C1.5 9.62365 2.02233 9.10525 2.66667 9.10525H13.1667ZM3.83333 20.6842H12V11.421H3.83333V20.6842Z"
        fill="currentColor"
      />
      <path
        d="M7.33333 12.5789V16.0526H5L5 12.5789H7.33333Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default EnterpriseTierIcon;
